import { useMemo } from "react";

export function useIsSquare(personalSettings) {
  return useMemo(() => {
    return (
      !personalSettings?.showTitle &&
      !personalSettings?.showSubtitle &&
      !personalSettings?.showLegend
    );
  }, [personalSettings]);
}
